// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Link } from 'react-router'
import { Col, Button, Row } from 'react-bootstrap'
import { ModuleItem } from '../components/moduleItem'
import { Message } from '../components/message'
import { evalRatingModule, getCategoriesString } from '../utils/enUtils.js'

export class PerformanceSummaryContent extends Component {
    constructor(props) {
        super(props)

        this.path = {
            modules: '/assets/images/Modules/'
        }

        this.viewPerformance = this.viewPerformance.bind(this)
        this.loadModuleItems = this.loadModuleItems.bind(this)
    }

    loadModuleItems() {
        if (this.props.activeModules.length === 0) {
            return (
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <Message
                            text={"You haven't assigned any module to " + this.props.activeWorkerName}
                        />
                    </Col>
                </Row>
            )
        }
        else {
            return (
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <section className="modules all-modules">
                            <h3 className="category-title">All Modules</h3>
                            {this.prepareModuleItems()}
                        </section>
                    </Col>
                </Row>
            )
        }
    }

    prepareModuleItems() {
        return this.props.activeModules.map((module, index) => {
            let globalModuleData = this.props.appData.globalModules.find(gmd => gmd.id === module.id)

            return (
                <ModuleItem
                    key={index}
                    image={globalModuleData.icon}
                    name={module.name}
                    status={evalRatingModule(module.completed, module.average_strikes)}
                    category={getCategoriesString(globalModuleData.category)}
                    summary={globalModuleData.summary}
                >
                    <Row>
                        <Col smOffset={6} sm={6}>
                            <Button bsStyle="primary" data-moduleName={module.name} onClick={this.viewPerformance}>View Performance</Button>
                        </Col>
                    </Row>
                </ModuleItem>
            )
        })
    }

    viewPerformance(e) {
        e.preventDefault()

        this.props.handleActiveModule(e.target.getAttribute('data-moduleName'))
        this.props.router.push('/performance/summary/content/details')
    }

    prepareBreadCrumb() {
        return (<div className="breadcrumb"><span><Link to="/performance">Performance Breakdown</Link></span>/</div>)
    }

    render() {
        return (
            <section className="training-content">
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <div className="main-header">
                            {this.prepareBreadCrumb()}
                            <h2 className="title">{this.props.activeWorkerName + "'s Content"}</h2>
                        </div>
                    </Col>
                </Row>
                {this.loadModuleItems()}
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/performanceSummaryContent.js